import SpaStart from "@/spa/views/SpaStart.vue";
import SpaType from "@/spa/views/SpaType.vue";
import SpaDayBooking from "@/spa/views/SpaDayBooking.vue";
import SpaDaySearch from "@/spa/views/SpaDaySearch.vue";
import SpaDayGuests from "@/spa/views/SpaDayGuests.vue";
import SpaDayArrivalTime from "@/spa/views/SpaDayArrivalTime.vue";
import SpaDaySpaGarden from "@/spa/views/SpaDaySpaGarden.vue";
import SpaDayDining from "@/spa/views/SpaDayDining.vue";
import SpaDayTreatments from "@/spa/views/SpaDayTreatments.vue";
import SpaDayTreatmentTimes from "@/spa/views/SpaDayTreatmentTimes.vue";
import SpaDayAddOns from "@/spa/views/SpaDayAddOns.vue";
import SpaDayDetails from "@/spa/views/SpaDayDetails.vue";
import SpaDaySummary from "@/spa/views/SpaDaySummary.vue";
import SpaDayPayment from "@/spa/views/SpaDayPayment.vue";
import SpaDayConfirmation from "@/spa/views/SpaDayConfirmation.vue";


import SpaTreatmentBooking from "@/spa/views/SpaTreatmentBooking.vue";
import SpaTreatmentSearch from "@/spa/views/SpaTreatmentSearch.vue";
import SpaTreatmentGuests from "@/spa/views/SpaTreatmentGuests.vue";
import SpaTreatmentTreatments from "@/spa/views/SpaTreatmentTreatments.vue";
import SpaTreatmentTreatmentTimes from "@/spa/views/SpaTreatmentTreatmentTimes.vue";
import SpaTreatmentAddOns from "@/spa/views/SpaTreatmentAddOns.vue";
import SpaTreatmentDetails from "@/spa/views/SpaTreatmentDetails.vue";
import SpaTreatmentSummary from "@/spa/views/SpaTreatmentSummary.vue";
import SpaTreatmentPayment from "@/spa/views/SpaTreatmentPayment.vue";
import SpaTreatmentConfirmation from "@/spa/views/SpaTreatmentConfirmation.vue";





import { createWebHashHistory, createRouter } from "vue-router";


const SpaRoutes = [
    {
        path: "",
        name: "spa_start",
        component: SpaStart,
        meta: { title: 'Book the Spa with your Rockliffe Account' }
    },
    {
        path: "/type",
        name: "spa_type",
        component: SpaType,
        meta: { title: 'Book the Spa with your Rockliffe Account' }
    },
    {
        path: "/day",
        name: "spa_day_booking",
        component: SpaDayBooking,
        children: [
            {
                path: "search",
                name: "spa_day_search",
                component: SpaDaySearch,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/guest",
                name: "spa_day_guests",
                component: SpaDayGuests,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/arrival",
                name: "spa_day_arrival_time",
                component: SpaDayArrivalTime,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/dining",
                name: "spa_day_dining",
                component: SpaDayDining,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/garden",
                name: "spa_day_garden",
                component: SpaDaySpaGarden,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/treatments",
                name: "spa_day_treatments",
                component: SpaDayTreatments,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/treatment-times",
                name: "spa_day_treatment_times",
                component: SpaDayTreatmentTimes,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/add-ons",
                name: "spa_day_add_ons",
                component: SpaDayAddOns,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/details",
                name: "spa_day_details",
                component: SpaDayDetails,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/summary",
                name: "spa_day_summary",
                component: SpaDaySummary,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
            {
                path: ":id/payment",
                name: "spa_day_payment",
                component: SpaDayPayment,
                meta: { title: 'Book A Spa Day with your Rockliffe Account' }
            },
        ]
    },


    {
        path: "/treatment",
        name: "spa_treatment_booking",
        component: SpaTreatmentBooking,
        children: [
            {
                path: "search",
                name: "spa_treatment_search",
                component: SpaTreatmentSearch,
                meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
            },
            {
                path: ":id/guest",
                name: "spa_treatment_guests",
                component: SpaTreatmentGuests,
                meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
            },
            {
                path: ":id/treatments",
                name: "spa_treatment_treatments",
                component: SpaTreatmentTreatments,
                meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
            },
            {
                path: ":id/treatment-times",
                name: "spa_treatment_treatment_times",
                component: SpaTreatmentTreatmentTimes,
                meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
            },
            {
                path: ":id/add-ons",
                name: "spa_treatment_add_ons",
                component: SpaTreatmentAddOns,
                meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
            },
            {
                path: ":id/details",
                name: "spa_treatment_details",
                component: SpaTreatmentDetails,
                meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
            },
            {
                path: ":id/summary",
                name: "spa_treatment_summary",
                component: SpaTreatmentSummary,
                meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
            },
            {
                path: ":id/payment",
                name: "spa_treatment_payment",
                component: SpaTreatmentPayment,
                meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
            },
        ]
    },


    {

        path: "/:id/day/confirmation",
        name: "spa_day_confirmation",
        component: SpaDayConfirmation,
        meta: { title: 'Book A Spa Day with your Rockliffe Account' }
    },

    {

        path: "/:id/treatment/confirmation",
        name: "spa_treatment_confirmation",
        component: SpaTreatmentConfirmation,
        meta: { title: 'Book A Spa Treatment with your Rockliffe Account' }
    }
];


const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        ...SpaRoutes
    ],
    scrollBehavior(/*to, from, savedPosition*/) {
        return { top: 0 }
    },

});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "Book the Spa with your Rockliffe Account";
    next();
});



export default router;